export default __webpack_public_path__ + "static/lobby1-28787dccce1d2d86875c8efd12cab48a.gif";